export const toolCallMessages = {
  "toolCall.websearch.empty": "No search results found.",
  "toolCall.websearch.provider": "Web search provider",
  "toolCall.execute.script": "Code Mode",
  "toolCall.execute.calls": "Nested tool calls",
  "toolCall.execute.more": "{count} additional calls omitted.",
  "toolCall.execute.truncated": "Native output truncated. Full output:",
  "toolCall.pending.waitingToRun": "Waiting to run...",
  "toolCall.error.label": "Error:",

  "toolCall.header.copyTitle": "Copy tool call title",
  "toolCall.header.copyAriaLabel": "Copy tool call title",
  "toolCall.header.copyOutputTitle": "Copy tool output",
  "toolCall.header.copyOutputAriaLabel": "Copy tool output",

  "toolCall.header.showInputTitle": "Show Tool Arguments",
  "toolCall.header.showInputAriaLabel": "Show Tool Arguments",
  "toolCall.header.hideInputTitle": "Hide Tool Arguments",
  "toolCall.header.hideInputAriaLabel": "Hide Tool Arguments",

  "toolCall.io.input": "Tool Input",
  "toolCall.io.output": "Tool Output",
  "toolCall.io.copyInputTitle": "Copy tool input",
  "toolCall.io.copyInputAriaLabel": "Copy tool input",
  "toolCall.io.copyOutputTitle": "Copy tool output",
  "toolCall.io.copyOutputAriaLabel": "Copy tool output",

  "toolCall.diff.label": "Diff",
  "toolCall.diff.label.withPath": "Diff · {path}",
  "toolCall.diff.viewMode.ariaLabel": "Diff view mode",
  "toolCall.diff.viewMode.split": "Split",
  "toolCall.diff.viewMode.unified": "Unified",
  "toolCall.diff.switchToSplit": "Switch to split view",
  "toolCall.diff.switchToUnified": "Switch to unified view",
  "toolCall.diff.enableWordWrap": "Enable word wrap",
  "toolCall.diff.disableWordWrap": "Disable word wrap",
  "toolCall.diff.copyPatch": "Copy patch",
  "toolCall.permission.diff.previous": "Previous diff page",
  "toolCall.permission.diff.next": "Next diff page",
  "toolCall.permission.diff.page": "Page {page} of {total}",
  "toolCall.permission.diff.reviewRequired": "Review every page or copy the complete patch to enable approval.",

  "toolCall.diagnostics.title": "Diagnostics",
  "toolCall.diagnostics.ariaLabel": "Diagnostics",
  "toolCall.diagnostics.ariaLabel.withLabel": "Diagnostics {label}",
  "toolCall.diagnostics.severity.error.short": "ERR",
  "toolCall.diagnostics.severity.warning.short": "WARN",
  "toolCall.diagnostics.severity.info.short": "INFO",

  "toolCall.renderer.toolName.shell": "Shell",
  "toolCall.renderer.toolName.fetch": "Fetch",
  "toolCall.renderer.toolName.invalid": "Invalid",
  "toolCall.renderer.toolName.plan": "Plan",
  "toolCall.renderer.toolName.applyPatch": "Apply patch",

  "toolCall.renderer.action.working": "Working...",
  "toolCall.renderer.action.writingCommand": "Writing command...",
  "toolCall.renderer.action.preparingEdit": "Preparing edit...",
  "toolCall.renderer.action.readingFile": "Reading file...",
  "toolCall.renderer.action.preparingWrite": "Preparing write...",
  "toolCall.renderer.action.preparingPatch": "Preparing patch...",
  "toolCall.renderer.action.planning": "Planning...",
  "toolCall.renderer.action.fetchingFromWeb": "Fetching from the web...",
  "toolCall.renderer.action.findingFiles": "Finding files...",
  "toolCall.renderer.action.searchingContent": "Searching content...",
  "toolCall.renderer.action.listingDirectory": "Listing directory...",

  "toolCall.renderer.bash.title.timeout": "Timeout: {timeout}",
  "toolCall.output.truncated": "[Output truncated for rendering; copy to access the full output]",
  "toolCall.output.tooLarge": "Structured output omitted from rendering because it is too large.",
  "toolCall.task.steps.truncated": "Showing the most recent {count} steps; older steps are omitted.",
  "toolCall.renderer.read.detail.offset": "Offset: {offset}",
  "toolCall.renderer.read.detail.limit": "Limit: {limit}",

  "toolCall.renderer.todo.empty": "No items planned",
  "toolCall.renderer.todo.status.pending": "Pending",
  "toolCall.renderer.todo.status.inProgress": "In progress",
  "toolCall.renderer.todo.status.completed": "Completed",
  "toolCall.renderer.todo.status.cancelled": "Cancelled",
  "toolCall.renderer.todo.title.plan": "Plan",
  "toolCall.renderer.todo.title.creating": "Creating plan",
  "toolCall.renderer.todo.title.completing": "Completing plan",
  "toolCall.renderer.todo.title.updating": "Updating plan",

  "toolCall.permission.status.required": "Permission Required",
  "toolCall.permission.status.queued": "Permission Queued",
  "toolCall.permission.requestedDiff.label": "Requested diff",
  "toolCall.permission.requestedDiff.withPath": "Requested diff · {path}",
  "toolCall.permission.queuedText": "Waiting for earlier permission responses.",
  "toolCall.permission.actions.allowOnce": "Allow Once",
  "toolCall.permission.actions.alwaysAllow": "Always Allow",
  "toolCall.permission.actions.deny": "Deny",
  "toolCall.permission.shortcuts.allowOnce": "Allow once",
  "toolCall.permission.shortcuts.alwaysAllow": "Always allow",
  "toolCall.permission.rejectReason.placeholder": "Optional feedback for Deny, e.g. use a safer command...",
  "toolCall.permission.errors.unableToUpdate": "Unable to update permission",

  "permissionApproval.title": "Requests",
  "permissionApproval.empty": "No pending requests.",
  "permissionApproval.kind.permission": "Permission",
  "permissionApproval.kind.question": "Question",
  "permissionApproval.kind.form": "Form",
  "formRequest.selectPlaceholder": "Select an option",
  "formRequest.openExternal": "Open external form",
  "formRequest.cancel": "Cancel",
  "formRequest.submit": "Submit",
  "formRequest.submitting": "Submitting...",
  "formRequest.errors.reply": "Unable to submit form",
  "formRequest.errors.cancel": "Unable to cancel form",
  "formRequest.errors.validation": "Complete all required fields.",
  "formRequest.customValuesPlaceholder": "Other values, separated by commas",
  "permissionApproval.questionCount.one": "{count} question",
  "permissionApproval.questionCount.other": "{count} questions",
  "permissionApproval.status.active": "Active",
  "permissionApproval.actions.closeAriaLabel": "Close",
  "permissionApproval.actions.goToSession": "Go to Session",
  "permissionApproval.actions.loadingSession": "Loading…",
  "permissionApproval.actions.loadSession": "Load Session",
  "permissionApproval.actions.allowOnce": "Allow Once",
  "permissionApproval.actions.alwaysAllow": "Always Allow",
  "permissionApproval.actions.deny": "Deny",
  "permissionApproval.rejectReason.placeholder": "Optional feedback for Deny, e.g. use a safer command...",
  "permissionApproval.fallbackHint": "Load session for more information.",
  "permissionApproval.errors.unableToUpdatePermission": "Unable to update permission",

  "toolCall.question.status.required": "Question Required",
  "toolCall.question.status.queued": "Question Queued",
  "toolCall.question.status.questions": "Questions",
  "toolCall.question.action.awaitingAnswers": "Awaiting answers...",
  "toolCall.question.title.questions": "Questions",
  "toolCall.question.title.askingQuestions": "Asking questions",
  "toolCall.question.type.one": "Question",
  "toolCall.question.type.other": "Questions",
  "toolCall.question.number": "Q{number}:",
  "toolCall.question.multiple": "Multiple",
  "toolCall.question.custom.title": "Type a custom answer",
  "toolCall.question.custom.label": "Custom answer",
  "toolCall.question.custom.placeholder": "Type your own answer",
  "toolCall.question.actions.submit": "Submit",
  "toolCall.question.actions.dismiss": "Dismiss",
  "toolCall.question.shortcuts.submit": "Submit",
  "toolCall.question.shortcuts.dismiss": "Dismiss",
  "toolCall.question.queuedText": "Waiting for earlier responses.",
  "toolCall.question.validation.answerAll": "Please answer all questions before submitting.",
  "toolCall.question.errors.unableToReply": "Unable to reply",
  "toolCall.question.errors.unableToDismiss": "Unable to dismiss",

  "toolCall.task.action.delegating": "Delegating...",
  "toolCall.task.sections.prompt": "Prompt",
  "toolCall.task.sections.steps": "Steps",
  "toolCall.task.sections.output": "Output",
  "toolCall.task.steps.count": "{count} steps",
  "toolCall.task.meta.agentModel": "Agent: {agent} • Model: {model}",
  "toolCall.task.meta.agent": "Agent: {agent}",
  "toolCall.task.meta.model": "Model: {model}",

  "toolCall.status.pending": "Pending",
  "toolCall.status.running": "Running",
  "toolCall.status.completed": "Completed",
  "toolCall.status.error": "Error",
  "toolCall.status.unknown": "Unknown",

  "toolCall.applyPatch.action.preparing": "Preparing apply_patch...",
  "toolCall.applyPatch.title.withFileCount.one": "{tool} ({count} file)",
  "toolCall.applyPatch.title.withFileCount.other": "{tool} ({count} files)",
  "toolCall.applyPatch.fileFallback": "File {number}",
} as const
